import { formatShortDate } from '../../lib/format.js';

export const ORIGIN_PART = 'Originated from this workflow';

export interface ReportScope {
  startDate: string;
  endDate: string;
  accountIds: number[];
  filters?: Record<string, unknown>;
}

export interface ScopeAccount {
  id: number;
  productName: string;
  networkLabel: string;
}

function distinct(values: string[]): string[] {
  return [...new Set(values.filter((value) => value !== ''))];
}

export function dateRangeLabel(startDate: string, endDate: string): string {
  return `${formatShortDate(startDate)} – ${formatShortDate(endDate)}`;
}

export function reportMetaParts(scope: ReportScope | null, accounts: ScopeAccount[]): string[] {
  if (scope === null) return [ORIGIN_PART];

  const inScope =
    scope.accountIds.length === 0
      ? accounts
      : accounts.filter((account) => scope.accountIds.includes(account.id));

  return [
    ORIGIN_PART,
    ...distinct(inScope.map((account) => account.productName)),
    ...(inScope.length === 0
      ? []
      : [distinct(inScope.map((account) => account.networkLabel)).join(', ')]),
    dateRangeLabel(scope.startDate, scope.endDate),
  ].filter((part) => part !== '');
}
